import { componentSizeMap } from '../../constants/size';

import type { ComponentSize } from '../../constants/size';

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default'];
};
